import { useState } from 'react';
import { User, ChevronDown, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/useAuth';

export function UserMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user) return null;

  const displayName = user.preferred_username || user.email || 'user';

  const handleLogout = () => {
    setOpen(false);
    logout();
  };

  return (
    <div className="relative [@media(pointer:coarse)]:hidden">
      <button
        data-testid="user-menu-button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Open user menu"
        aria-expanded={open}
        className="flex items-center gap-2 px-2 py-1.5 text-vibe-text-secondary hover:text-vibe-text hover:bg-vibe-bg-tertiary rounded transition-colors"
      >
        <div className="w-6 h-6 rounded-full bg-vibe-accent/20 flex items-center justify-center">
          <User className="w-3.5 h-3.5 text-vibe-accent" />
        </div>
        <span className="text-sm font-medium truncate max-w-[10rem]">{displayName}</span>
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <>
          <div
            data-testid="user-menu-backdrop"
            className="fixed inset-0 z-[10006]"
            onClick={() => setOpen(false)}
            aria-hidden="true"
          />
          <div
            data-testid="user-menu"
            className="absolute right-0 top-full mt-1 z-[10007] min-w-[14rem] bg-vibe-bg-secondary border border-vibe-border rounded shadow-lg overflow-hidden"
          >
            <div className="px-3 py-2 border-b border-vibe-border">
              <div className="text-sm font-medium text-vibe-text truncate">{user.name || displayName}</div>
              <div className="text-xs text-vibe-text-secondary truncate" title={user.email}>{user.email}</div>
            </div>
            <button
              data-testid="user-menu-logout"
              onClick={handleLogout}
              className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-400 hover:bg-vibe-bg-tertiary transition-colors"
            >
              <LogOut className="w-4 h-4" />
              <span>Sign Out</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
}
